import { getCampaignName, getQueryString } from '@efe-activity-fe-util/core'
import {
    STORE_PAGE_RULES,
    CPP_LINK_RULES,
    SHAME_PAGE_RULES,
} from '../constants/page'
import { getHtmlFileNameWithoutExt, getPageLanguage } from './general'

const campaignName = getCampaignName()
const utmMedium = getQueryString('utm_medium')

// export const isStorePage = STORE_PAGE_RULES.some((reg) =>
//     new RegExp(reg).test(campaignName)
// )

export const isStorePage = getHtmlFileNameWithoutExt() === 'store'
export const isShortPage = getHtmlFileNameWithoutExt() === 'short'

console.log(isStorePage)

export const isTextCppLink = CPP_LINK_RULES.some((reg) =>
    new RegExp(reg).test(utmMedium)
)

export const isShamePage = SHAME_PAGE_RULES.some((reg) =>
    new RegExp(reg).test(campaignName)
)

export const isEn = () => {
    return getPageLanguage() === 'en'
}

export const isDe = () => {
    return getPageLanguage() === 'de'
}

export const isFr = () => {
    return getPageLanguage() === 'fr'
}

export const isTr = () => {
    return getPageLanguage() === 'tr'
}
